import { Alert, AlertColor, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar, Typography } from "@mui/material"
import { useState } from "react"
import { isEmpty, isNil } from "lodash/fp"
import { doUpload } from "./functions"
import { MuiFileInput } from "mui-file-input"
import { CloudUploadOutlined, NotificationsActiveOutlined } from "@mui/icons-material"
import alertPropaties from './alert-propaties.json'
import log from "loglevel"
import { inspect } from "./inspect"
import { AlertPropaty } from "../../types"

export const AdminMenu = () => {
    const [uploadFile, setUploadFile] = useState<File | null>(null)
    const [open, setOpen] = useState<boolean>(false)
    const [alertPropaty, setAlertPropaty] = useState<AlertPropaty>(undefined)
    const [alertStatus, setAlertStatus] = useState<AlertColor | undefined>(undefined)

    const handleInput = (uploadFile: File | null) => {
        setUploadFile(uploadFile)
    }

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setUploadFile(null)
        setOpen(false)
    }

    const handleSubmit = async (uploadFile: File | null) => {
        if (!isNil(uploadFile)) {
            setAlertPropaty(alertPropaties['upload'])
            doUpload(uploadFile).then((result) => {
                if (result) {
                    setAlertStatus("success")
                } else {
                    setAlertStatus("error")
                }
            }).catch((error) => {
                log.error(`[index.handleSubmit] Upload failed.`, inspect({ error }))
                setAlertStatus("error")
            })

        } else {
            setAlertStatus("error")
        }
        handleClose()
    }

    const handleAlertClose = () => {
        setAlertStatus(undefined)
        setAlertPropaty(undefined)
    }

    return (
        <Box display="grid" justifyContent={"center"}>
            <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">発送通知できる君（仮）</Typography>
            <Box display={"flex"} justifyContent={"center"}>
                <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} marginTop={3}>
                    <Box display="grid" paddingTop={3} color="gray">
                        <Typography display={"flex"} alignContent={"center"}><NotificationsActiveOutlined />発送通知（CSVファイルをアップロード）</Typography>
                        <Button variant="contained" onClick={handleClickOpen} sx={{ marginY: 1, color: '#FFFFFF' }}><CloudUploadOutlined />アップロード</Button>
                    </Box>
                </Box>
            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault()
                        handleClose()
                    }
                }}
            >
                <DialogTitle>ファイルアップロード</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        WMSからダウンロードしたcsvファイルを選択してください。
                    </DialogContentText>
                    <MuiFileInput value={uploadFile} onChange={handleInput} variant="outlined" />
                    <br />
                    <Typography variant="caption" component="div" gutterBottom>csv ファイルのみ、ファイルサイズは5MB以内。</Typography>
                    {!(uploadFile) && (
                        <Typography variant="caption" component="div" color="error.main" gutterBottom>ファイルを選択してください。</Typography>)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>キャンセル</Button>
                    <Button type="submit" onClick={async () => handleSubmit(uploadFile)} disabled={isNil(uploadFile)}>送信</Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={!isEmpty(alertStatus)} autoHideDuration={5000} onClose={handleAlertClose}>
                <Alert severity={alertStatus}>
                    <AlertTitle>{!isEmpty(alertStatus) && !isNil(alertPropaty) ? alertPropaty[alertStatus as keyof typeof alertPropaty]["alertTitle"] : ""}</AlertTitle>
                    {!isEmpty(alertStatus) && !isNil(alertPropaty) ? alertPropaty[alertStatus as keyof typeof alertPropaty]["alertMessage"] : ""}
                </Alert>
            </Snackbar>
        </Box>
    )
}